export default "__VITE_ASSET__q6IE9EtU__"